import { Component, OnDestroy, OnInit, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ThemeToggleComponent, UI } from 'src/app/components/ui';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [RouterLink, RouterOutlet, ...UI, ThemeToggleComponent],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit, OnDestroy {
  readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private navigationSub: Subscription | null = null;
  year = new Date().getFullYear();

  readonly isAuthenticated = computed(() => this.auth.isAuthenticated());

  ngOnInit(): void {
    this.navigationSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event.urlAfterRedirects.includes('#')) {
          return;
        }

        window.scrollTo({ top: 0, behavior: 'auto' });
      });
  }

  ngOnDestroy(): void {
    this.navigationSub?.unsubscribe();
  }
}
